import { render, staticRenderFns } from "./catalog-list-index.vue?vue&type=template&id=3312b428"
import script from "./catalog-list-index.vue?vue&type=script&lang=js"
export * from "./catalog-list-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FeaturedAlternative: require('/var/www/components/featured/featured-alternative.vue').default,FilterDesktop: require('/var/www/components/filter/filter-desktop.vue').default,HeadingH2: require('/var/www/components/heading/heading-h2.vue').default,CatalogItemLargeMobile: require('/var/www/components/catalog/catalog-item/catalog-item-large-mobile.vue').default,CatalogIndexSwiper: require('/var/www/components/catalog/catalog-index-swiper.vue').default,ButtonTypical: require('/var/www/components/button/button-typical.vue').default})
